<template>
  <div class="dialog">
    <el-dialog v-dialogDrag :visible.sync="fileDialog" :close-on-click-modal="false"
    :close-on-press-escape="false" title="添加模型文件" width="600px" @close="cancel">
      <el-tree ref="localTree" :load="getlocalTree" :props="defaultFileProps" :check-on-click-node="true" class="tree"
        lazy accordion highlight-current show-checkbox @check="currentOrgChangeHandler" :check-strictly="true" >
        <template #default="{ data }">
          <span class="treeitem">
            <img v-if="data.isFolder == 0" :src="className(data)" class="img" alt="" />
            <img v-else :src="icon" class="img" alt="" />
            {{ data.folderName }}
          </span>
        </template>
      </el-tree>
      <span slot="footer">
        <el-button  size="small" @click="cancel" plain>取 消</el-button >
        <el-button type="primary" size="small" @click="filerecelocationBtn" >确 定</el-button >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import docService from '@/CommonDP/service/doc-service';
import bimManage from "@/xgzdService/bimManage-service"
import { tableRowIcon } from '@/CommonDP/utils/docPublic';
export default {
  props:{
    nodeId:{
      type:String,
      required:true
    }
  },
  data(){
    return{
      fileDialog:false,
      defaultFileProps: {
        children: 'childList',
        label: 'folderName',
        isLeaf: 'leaf'
      },
      node_had: {},
      resolve_had: {},
      icon: require('@/CommonDP/assets/doc/folder_icon.png'),
      currentFile:[],
    }
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj
    })
  },
  methods:{
    showDialog(){
      
      this.fileDialog=true;
    },
    className(row) {
      return tableRowIcon(row);
    },
    async getlocalTree(node, resolve) {
      const prjId =  this.prjInfo.prjId;
      if (node.level === 0) {
        this.node_had = node; // 这里是关键！在data里面定义一个变量，将node.level == 0的node存起来
        this.resolve_had = resolve; // 同上，把node.level == 0的resolve也存起来
        const params = {
          folderId: 0,
          isRead: 1,
          priviAll: '1',
          prjId
        };
        const result = await docService.queryTree(params);
        const list = result.data.filter( ({ folderId }) => folderId !== 'recycle' );
        const array=this.formatData(list);
        this.$nextTick(() => {
          node.childNodes[0].expanded = true;
          node.childNodes[0].loadData();
        });
        return resolve(array);
      } else {
        const params = {
          folderId: node.data.folderId,
          isRead: node.data.isRead,
          priviAll: node.data.priviAll,
          prjId
        };
        const res=await docService.queryTree(params);
        const array=this.formatData(res.data);
        const list =array.filter((item)=>item.fileType===7||item.isFolder==1||item.fileType===18||item.fileType===19)  // 只能选择rvt/skp/3dm文件
        const statusList =list.filter((item)=>item.status==2||item.status==6||item.status==0)  // 选择轻量化成功的
        return resolve(statusList);
      }
    },
    formatData(params){
      let data = params;
      data.map((item) => {
        if(item.hasOwnProperty('childList')&&item.isFolder!=0){
          item.disabled = true;
          if(item.childList&&item.childList.length>0)this.formatData(item.childList)
        }
      });
      return data;
    },
    async filerecelocationBtn(){
      const {nodeId,currentFile}=this;
      if(currentFile.length>0){
        const params=currentFile.map(item=>{
          return{
            modeId:item.folderId,
            modeName:item.folderName,
            modelFileType:item.fileType,
            modelFileVersion:item.fileVersion,
            nodeId,
            parentId:item.parentId
          }
        })
        await bimManage.addMoDel(params)
        await this.$message.success("添加成功");
        await this.$emit("childMethod")
        this.fileDialog=false;
      }else{
        this.$message.warning("请选择要添加的模型")
      }
      
      
    },
    cancel(){
      this.$emit("childMethod");
      this.fileDialog=false;
    },
    currentOrgChangeHandler(val, currentChecked) {
      this.currentFile = currentChecked.checkedNodes;
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog{
  /deep/.el-dialog__body{
    height: 500px;
    overflow: auto;
  }
  /deep/.el-checkbox__input.is-disabled .el-checkbox__inner{
    display: none;
  }
}
.treeitem{
  display: flex;
  align-items: center;
  .img{
    margin-right: 6px;
  }
}
</style>
